module.exports = __webpack_public_path__ + "img/wide_selection_icon.1980ebef.svg";